import React from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export interface IToolbarSwitchProps
  extends React.HTMLAttributes<HTMLInputElement> {
  prefix?: string;
  label?: string;
  onChange?: (value: any) => void;
  defaultChecked?: boolean;
  inline?: boolean;
}

const B = styled.b`
  position: relative;
  display: inline-block;
  vertical-align: middle;

  input {
    position: absolute;
    opacity: 0 !important;
    pointer-events: none;
  }

  input + i {
    background-color: var(--builder-input-background);
    height: 18px;
    border-radius: 9px;
    padding: 0 1px;
  }

  input:checked + i {
    text-align: right;
    background-color: #0a6fb7;
  }

  input:focus + i {
    box-shadow: 0 0 0 1px var(--builder-focus-outline);
  }
`;

export const ToolbarSwitch = ({
  onChange,
  defaultChecked,
  prefix,
  label,
  inline,
}: IToolbarSwitchProps) => {
  return (
    <B>
      <input
        type="checkbox"
        onChange={(e) => {
          onChange?.(e.target.checked);
        }}
        defaultChecked={defaultChecked}
        css={css`
          position: absolute;
          opacity: 0 !important;
          pointer-events: none;
          font-family: sans-serif;
          outline: none;
        `}
      />
      <i
        css={css`
          width: 32px;
          display: inline-block;
          text-align: left;
          margin: 2px 0;

          ::before {
            content: "";
            width: 14px;
            height: 14px;
            border-radius: 50%;
            border: 1px solid #eee;
            display: inline-block;
            margin-top: 1px;

            background: linear-gradient(to bottom, #fff, #c1c1c1);
            box-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
          }
        `}
      ></i>
    </B>
  );
};
